import { TooltipWrapper } from '../adminComponents';
import { formatDateTimeShort } from '../helpers';
import { ScheduledIcon } from '../assets';

export const ScheduledIconTooltip = ({
  scheduledFor,
  timeZone,
}: {
  scheduledFor: string;
  timeZone: string;
}) => {
  return (
    <TooltipWrapper
      tooltip={`Scheduled for ${formatDateTimeShort(
        scheduledFor ?? '',
        timeZone ?? ''
      )} <br/> Timezone: ${timeZone}`}
      tooltipWidthSM="250px"
      style={{ width: '22px', height: '22px' }}
    >
      <ScheduledIcon />
    </TooltipWrapper>
  );
};
